/**
 * Prefetches a page by creating a `<link rel="prefetch">` element for the given URL.
 * This helps to load the specified page in advance, improving navigation performance.
 *
 * The prefetch link is appended to the document head after the window "load" event.
 *
 * @param slug - The slug of the page to prefetch.
 *
 * @example
 * prefetchPage("/menu");
 * This will prefetch the "/menu" page after the window has loaded.
 */
export function prefetchPage(slug) {
    const addPrefetchLink = () => {
        const link = document.createElement("link");
        link.rel = "prefetch";
        link.href = slug;
        link.as = "document";
        document.head.appendChild(link);
        console.debug(`Prefetching page: ${slug}`);
    };
    window.addEventListener("load", addPrefetchLink);
}
